<lib-validation-problems [saving$]="saving$"></lib-validation-problems>

<div class="margin-top-15">
    <lib-know-your-customer-details [order]="order"></lib-know-your-customer-details>
</div>

@if (order.knowYourCustomerCriteria?.party) {
<div>
    <h3 class="margin-bottom-5">{{ 'orders.criteria' | transloco }}</h3>
    <lib-parties-list [uiConfiguration]="uiConfiguration.debtorsConfiguration!" [order]="order" [observableParties$]="party$" [isEditable]="false">
    </lib-parties-list>
</div>
}